export default __webpack_public_path__ + "static/media/TRUE_LOCAL.51bb6846.png";